<template>
  <article class="tabs" :class="custom_class">
    <ul class="tabs__nav">
      <li
        v-for="(tab, idx) in tabs" :key="idx"
        :class="['tabs__nav-item', { 'tablet-lg-down': tab.name == 'description' }]"
        @click.prevent="setActive(tab)">
        <a :class="{ active: tab.isActive }">{{ tab.name }}</a>
      </li>
    </ul>
    <section class="tabs__content">
      <slot></slot>
    </section>
  </article>
</template>

<script>
export default {
  props: [ 'custom_class' ],

  data () {
    return {
      tabs: []
    }
  },

  created () {
    this.tabs = this.$children
  },

  methods: {
    setActive (selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name.toLowerCase() == selectedTab.name.toLowerCase()
      })
    }
  }
}
</script>
